var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"page__title"},[_vm._v(_vm._s(_vm.page_title || 'Users')+":")]),_vm._v(" "),_c('div',{staticClass:"page__additional-btn-wrapper"},[_c('router-link',{attrs:{"to":_vm.additional_btn_url}},[_c('button',{staticClass:"page__additional-btn",on:{"click":function($event){return _vm.$emit('callback', 'not needed but you can pass something here to send to parent!')}}},[_vm._v(_vm._s(_vm.additional_btn_label))])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3dca5943","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentHeader.vue
// module id = 44
// module chunks = 0